import * as yup from 'yup';

export interface IFormValues {
  name: string;
  style: string;
  size: string;
  settingsActionName: string;
  description: string;
}

export const validationSchema = yup.object({});
